console.log("\n%c DermNet Pro® v3.0.1", "color:#fff;font-size:12px;font-weight:400; padding:0.45rem 0.75rem; margin: 0rem auto 1rem auto; font-family: Metropolis, Helvetica, sans-serif; border: 2px solid #0dd8d8; border-radius: 4px;background-size: cover;background-repeat: no-repeat;border: double 1px transparent;background-image: linear-gradient(#282828, #282828), radial-gradient(circle at top left, #1C48AB, #24ACF0);background-origin: border-box;background-clip: padding-box, border-box;")

/*------------------------------------------------------------------ 
Import styles
------------------------------------------------------------------*/

import '../styles/main.scss';
import '../styles/portal.scss';


/*------------------------------------------------------------------ 
Import scripts
------------------------------------------------------------------*/

import { $, $$ } from './utilities/helpers';

/*------------------------------------------------------------------ 
Sentry
------------------------------------------------------------------*/

import * as Sentry from '@sentry/browser';

if (!window.location.host.includes('dev.')) {
    Sentry.init({
        dsn: 'https://af73c4a168e04834596fdc17a97c87ec@o234140.ingest.us.sentry.io/4508689923178496',

        beforeSend(event, hint) {
            const error = hint?.originalException;
            const message =
                typeof error === 'string' ? error :
                    error?.message ||
                    event?.exception?.values?.[0]?.value;

            if (
                typeof message === 'string' &&
                (message.includes('heap-api.com')
                    || message.includes('datadoghq.com')
                    || message.includes("Cannot read properties of null (reading 'scrollX')")
                )
            ) {
                return null;
            }

            return event;
        }
    });
}

let DEBUG = window.location.host.includes('ddev.sited');

let $mobile_search = $('.frame__magnifying');

if ($mobile_search) {
    $mobile_search.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.toggle('mobileSearchActive');
        document.body.classList.remove('mobileMenuActive');
        setTimeout(() => {
            if (document.body.classList.contains('mobileSearchActive')) {
                document.querySelector('.js-omni-search-input').focus();
            }
        }, 220);
    });
}


/*------------------------------------------------------------------
Accordions
------------------------------------------------------------------*/

import { Accordion } from '@/components/accordion'
if ($('.js-accordion-element')) { $$('.js-accordion-element').forEach(element => new Accordion(element)); }

/*------------------------------------------------------------------
Glossary
------------------------------------------------------------------*/

import { Glossary } from '@/components/glossary'
if ($('.js-glossary-input')) new Glossary($('.js-glossary-grid'), $('.js-glossary-input'), $$('.js-glossary-letter'), $('.js-clear-filters'));


/*------------------------------------------------------------------
Cases
------------------------------------------------------------------*/

import { Cases } from '@/components/cases'
if ($('.js-cases-input')) { new Cases($('.js-cases-grid'), $('.js-cases-input'), $$('.js-case-letter'), $('.js-clear-filters')) }


/*------------------------------------------------------------------
Omni search
------------------------------------------------------------------*/

import { OmniSearch } from '@/components/omni-search';
if ($('.js-omni-search') && $('.js-logged-in-user')) { window.omni = new OmniSearch($('.js-omni-search')) }


/*------------------------------------------------------------------
Images
------------------------------------------------------------------*/

import { Galleries } from '@/components/galleries';
if ($('.js-galleries-grid')) { new Galleries($('.js-galleries-grid'), $('.js-images-input'), $('.js-clear-filters'), $('.js-search-info')) }


/*------------------------------------------------------------------
Images
------------------------------------------------------------------*/

import { Images } from '@/components/images';
if ($('.js-images-grid')) { new Images($('.js-images-grid'), $('.js-images-input'), $('.js-clear-filters'), $('.js-search-info')) }


/*------------------------------------------------------------------
Resources
------------------------------------------------------------------*/

import { Resources } from '@/components/resources';
if ($('.js-resources-grid')) { window._resources = new Resources($('.js-resources-grid'), $('.js-resources-input'), $('.js-clear-filters'), $('.js-search-info')) }

import { Gallery } from '@/components/gallery'

/*------------------------------------------------------------------
Single resource
------------------------------------------------------------------*/

import '@/components/resource';

/*------------------------------------------------------------------
Profile
------------------------------------------------------------------*/

import '@/components/induction';
import '@/components/profile';
import '@/components/notifications';
import '@/components/login';
import '@/components/topics';
import '@/components/features';
import '@/components/signup';
import '@/components/subscriptions';
import '@/components/action-button';

/*------------------------------------------------------------------
Start the app
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {


    if (!DEBUG) {
        const executeOnReady = () => {

            heap.identify(window.user_email);

            const properties = {};

            if (window.user_firstname && window.user_surname) properties.name = `${window.user_firstname} ${window.user_surname}`;
            if (window.state) properties.state = window.state;
            if (window.country) properties.country = window.country;
            if (window.position) properties.position = window.position;
            if (window.occupation) properties.occupation = window.occupation;
            if (window.profession) properties.profession = window.profession;
            if (window.medical_title) properties.medical_title = window.medical_title;

            heap.addUserProperties(properties);
        }

        heap.onReady(executeOnReady);


    }

    document.addEventListener('gesturestart', function (e) {
        e.preventDefault();
    });

    const isValidEmail = (email) => {
        const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return regex.test(email);
    }

    if (window.user_email && isValidEmail(window.user_email)) {
        Sentry.setUser({
            email: window.user_email
        });
    }

    let $password_fields = $$('input.text.password');

    if ($password_fields) {

        $password_fields.forEach($field => {

            let $toggle = document.createElement('a');
            $toggle.classList.add('password-toggle');
            $toggle.innerHTML = '<span><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M480.09-328.92q62.99 0 106.99-44.09 44-44.09 44-107.08 0-62.99-44.09-106.99-44.09-44-107.08-44-62.99 0-106.99 44.09-44 44.09-44 107.08 0 62.99 44.09 106.99 44.09 44 107.08 44ZM480-384q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 172q-122.31 0-225.54-64.89-103.23-64.88-165.69-170.8-5-7.62-6.81-15.64-1.8-8.02-1.8-16.46 0-8.44 1.8-16.67 1.81-8.23 6.81-15.85 62.46-105.92 165.69-170.8Q357.69-748 480-748q122.31 0 225.54 64.89 103.23 64.88 165.69 170.8 5 7.62 6.81 15.64 1.8 8.02 1.8 16.46 0 8.44-1.8 16.67-1.81 8.23-6.81 15.85-62.46 105.92-165.69 170.8Q602.31-212 480-212Zm0-268Zm0 216q112 0 207-58t146-158q-51-100-146-158t-207-58q-112 0-207 58T127-480q51 100 146 158t207 58Z"/></svg></span>';
            $field.parentNode.insertBefore($toggle, $field.nextSibling);

            $toggle.addEventListener('click', (e) => {
                e.preventDefault();
                if ($field.type === 'password') {
                    $field.type = 'text';
                    $toggle.innerHTML = '<span><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M587.08-587.08q16.38 16.39 29.19 43.77 12.81 27.39 15.57 55.54 0 11.54-8.01 19.54t-19.14 8q-11.95 0-20.24-8-8.3-8-8.3-19.54.85-20.38-5.84-37-6.69-16.61-18.69-29.11t-28.5-18.31q-16.5-5.81-36.12-4.58-11.54.39-19.92-7.43-8.39-7.82-8.77-18.95-.39-11.54 7.42-19.93 7.81-8.38 19.35-8.76 28.92 2 56.19 14.11 27.27 12.12 45.81 30.65ZM480-696q-18.99 0-37.29 1.63-18.3 1.62-36.4 5.19-10.7 1.72-20.93-4.05t-13.07-16.04q-2.85-10.65 2.54-19.61 5.38-8.96 16.3-10.83 22.39-4.52 44.39-6.4Q457.55-748 480-748q125.92 0 232.85 63.5Q819.77-621 875.97-508.57q3.87 7.49 5.18 14.24 1.31 6.75 1.31 14.33t-1.5 14.33q-1.5 6.75-4.5 14.36-18.13 36.28-44.07 67.64-25.93 31.36-56.55 59.21-8.3 7.31-18.76 6.88-10.47-.42-18.16-9.12-7.69-8.71-6.38-18.62 1.31-9.91 9.61-18.22 29.08-24.54 51.75-53.65Q816.57-446.31 833-480q-49-101-144.5-158.5T480-696Zm0 484q-123.31 0-227.54-64.5-104.23-64.5-165.38-172-4.92-7.42-6.23-15.37-1.31-7.95-1.31-16.16 0-8.2 1.5-16.32 1.5-8.11 6.5-15.34 25.31-45.77 57.8-85.14 32.5-39.36 74.66-70.63l-82.31-81.93q-8.3-7.92-8.69-17.69-.38-9.77 8.31-18.46 8.69-8.69 18.58-8.69 9.88 0 18.57 8.69l611.08 611.08q8.31 8.31 8.31 18.07 0 9.77-8.31 18.08-8.69 8.69-18.58 8.69-9.88 0-18.57-8.69L642.62-243.85q-38.79 16.69-79.64 24.27Q522.14-212 480-212ZM257.16-629.31q-41.16 29.16-75.2 65.92Q147.92-526.62 127-480q49 101 144.5 158.5T480-264q31.98 0 62.84-4.46 30.85-4.46 60.47-14.69L543.69-342q-15.15 7.31-31.27 10.19-16.11 2.89-32.42 2.89-63.08 0-107.08-44t-44-107.08q0-16.31 4.08-32.42 4.08-16.12 9-31.27l-84.84-85.62ZM528-528Zm-76.77 86.77Z"/></svg></span>';
                } else {
                    $field.type = 'password';
                    $toggle.innerHTML = '<span><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M480.09-328.92q62.99 0 106.99-44.09 44-44.09 44-107.08 0-62.99-44.09-106.99-44.09-44-107.08-44-62.99 0-106.99 44.09-44 44.09-44 107.08 0 62.99 44.09 106.99 44.09 44 107.08 44ZM480-384q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28Zm0 172q-122.31 0-225.54-64.89-103.23-64.88-165.69-170.8-5-7.62-6.81-15.64-1.8-8.02-1.8-16.46 0-8.44 1.8-16.67 1.81-8.23 6.81-15.85 62.46-105.92 165.69-170.8Q357.69-748 480-748q122.31 0 225.54 64.89 103.23 64.88 165.69 170.8 5 7.62 6.81 15.64 1.8 8.02 1.8 16.46 0 8.44-1.8 16.67-1.81 8.23-6.81 15.85-62.46 105.92-165.69 170.8Q602.31-212 480-212Zm0-268Zm0 216q112 0 207-58t146-158q-51-100-146-158t-207-58q-112 0-207 58T127-480q51 100 146 158t207 58Z"/></svg></span>';
                }
            });

        });
    }

    /*------------------------------------------------------------------
    Show the grid overlay
    ------------------------------------------------------------------*/

    document.addEventListener('keydown', (e) => {
        if (e.key === 'g' && e.shiftKey && e.metaKey) {
            document.body.classList.toggle('show-grid');
        }
    });

    /*------------------------------------------------------------------
    Post Load classname removal
    ------------------------------------------------------------------*/

    $$('.js-postload').forEach(element => element.classList.remove('js-postload'));


    /*------------------------------------------------------------------
    Feedback link insertion
    ------------------------------------------------------------------*/

    let $feedback_link = $$('.js-feedback-link');

    if ($feedback_link) {
        $feedback_link.forEach($link => {
            $link.addEventListener('click', (e) => {
                e.preventDefault();
                let url = $link.getAttribute('href');
                url = url + '?URL=' + window.location.href;
                window.location.href = url;
            });
        });
    }

    if (window.location.href.includes('website-feedback')) {
        let url_filters = new URLSearchParams(window.location.search);
        for (const [key, value] of url_filters.entries()) {
            if (key === 'URL') {
                let url_input = $('#WebsiteFeedbackForm_FormPage_URL');
                if (url_input) url_input.value = value;
            }
        }
    }


    /*------------------------------------------------------------------
    Wrap orphaned tables in a warpper element
    ------------------------------------------------------------------*/

    let $tables = $$('table');

    if ($tables) {
        $tables.forEach(table => {

            if (table.closest('.table-wrapper')) return;

            let wrapper = document.createElement('div');
            wrapper.classList.add('table-wrapper');
            let innerWrapper = document.createElement('div');

            innerWrapper.classList.add('table-wrapper__inner');
            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(innerWrapper);
            innerWrapper.appendChild(table);

        });

        setTimeout(() => {
            /*------------------------------------------------------------------
            Table interactions
            ------------------------------------------------------------------*/

            let $tables = $$('.table-wrapper');

            if ($tables) {
                $tables.forEach(table => {
                    // on horizontal scroll, if we reach the end

                    let $inner = table.querySelector('.table-wrapper__inner');
                    let $table = table.querySelector('table');

                    if ($inner && $table) {
                        $inner.addEventListener('scroll', function () {
                            if ($inner.scrollLeft + $inner.clientWidth >= $table.clientWidth) {
                                table.classList.add('end');
                            } else {
                                table.classList.remove('end');
                            }
                        });
                    }
                });
            }

        }, 1000);


        const overFlowTables = () => {
            let $tables = $$('.table-wrapper');

            if ($tables) {
                $tables.forEach(table => {

                    // if the table inside of the wrapper is wider than the wrapper then add a class
                    let $inner = table.querySelector('.table-wrapper__inner');
                    let $table = table.querySelector('table');

                    if ($inner && $table) {
                        if ($table.clientWidth > $inner.clientWidth) {
                            table.classList.add('overflow');
                        } else {
                            table.classList.remove('overflow');
                        }
                    }
                })
            }

        };

        window.addEventListener('resize', () => overFlowTables());

        overFlowTables();
    }

    /*------------------------------------------------------------------
    Sensitive images (WYSIWYG only)
    ------------------------------------------------------------------*/

    let $sensitiveImages = $$('[data-sensitive="true"]');

    if ($sensitiveImages) {
        $sensitiveImages.forEach(image => {
            image.addEventListener('click', (e) => {
                e.preventDefault();
                image.removeAttribute('data-sensitive');
            });
        });
    }


    /*------------------------------------------------------------------
    Galleries
    ------------------------------------------------------------------*/

    if ($('.js-gallery')) {


        if ($('.js-gallery')) $$('.js-gallery').forEach(element => new Gallery(element));

        let $sliders = $$('.js-gallery');

        if ($sliders) {

            $sliders.forEach(sliderParent => {

                let gallery = new Gallery(sliderParent);

                const slider = sliderParent.querySelector('.gallery__slides');
                let isDown = false;
                let startX;
                let scrollLeft;

                slider.addEventListener('mousedown', (e) => {
                    isDown = true;
                    slider.classList.add('active');
                    startX = e.pageX - slider.offsetLeft;
                    scrollLeft = slider.scrollLeft;
                });

                slider.addEventListener('mouseleave', () => {
                    isDown = false;
                    slider.classList.remove('active');
                });

                slider.addEventListener('mouseup', (e) => {
                    isDown = false;
                    slider.classList.remove('active');
                    if (startX === e.pageX - slider.offsetLeft) gallery.render(e.target);
                });

                slider.addEventListener('mousemove', (e) => {
                    if (!isDown) return;
                    e.preventDefault();
                    slider.scrollLeft = scrollLeft - (e.pageX - slider.offsetLeft - startX) * 1;
                });

            });

        }
    }


    if ($('.js-bento-gallery')) {


        let $sliders = $$('.js-bento-gallery');

        if ($sliders) {

            $sliders.forEach(sliderParent => {

                let gallery = new Gallery(sliderParent);

                const slider = sliderParent.querySelector('.gallery__slides');

                slider.addEventListener('mousedown', (e) => {
                    gallery.render(e.target);
                });

            });

        }
    }


    /*------------------------------------------------------------------
    Galleries
    ------------------------------------------------------------------*/

    let $newsletter = $('.js-newsletter-form');

    if ($newsletter) {
        $newsletter.addEventListener("submit", function (event) {
            event.preventDefault();
            $newsletter.classList.add('busy');
            fetch($newsletter.getAttribute('action'), {
                method: 'POST',
                body: new FormData($newsletter),
            })
                .then((response) => response.json())
                .then((data) => {

                    if (data.code === 200) {
                        // Reset the form
                        $newsletter.reset();

                        $newsletter.insertAdjacentHTML('beforeend', `<p class="colour--white" style="display: inline-block;font-size: 1.4rem;width: 100%;margin-top:0;"><b>${data.message}</b></p>`);
                    }

                    $newsletter.classList.remove('busy');

                })
                .catch((data) => {
                    $newsletter.classList.remove('busy');
                });
        });
    }


    /*------------------------------------------------------------------
    Sidebar form
    ------------------------------------------------------------------*/

    let $form = $(".sidebar-wrap__sidebar__form form");

    if ($form) {
        $form.addEventListener("submit", function (event) {
            event.preventDefault();
            $form.classList.add('busy');
            fetch($form.getAttribute('action'), {
                method: 'POST',
                body: new FormData($form),
            })
                .then((response) => response.json())
                .then((data) => {

                    if (data.success === true) {
                        // Reset the form
                        $form.reset();

                        $form.insertAdjacentHTML('beforeend', data.message);
                    }

                    $form.classList.remove('busy');

                })
                .catch((data) => {
                    $form.classList.remove('busy');
                });
        });
    }

    /*------------------------------------------------------------------
    Gloassary elements
    ------------------------------------------------------------------*/

    let $glossary_terms = $$('.js-glossary-term');

    if ($glossary_terms) {
        $glossary_terms.forEach($term => {

            let content_added = false;

            // Get the content
            let content = $term.getAttribute('data-term-definition');

            // Convert from base64 to string        
            let decoded_content = atob(content);

            $term.addEventListener('mouseenter', (e) => {
                e.preventDefault();

                // Figure out if the $term is on the left or rigth side of the screen
                let rect = $term.getBoundingClientRect();
                let left = rect.left;
                let width = window.innerWidth;
                let half = width / 2;

                // Remove left and right class names
                $term.classList.remove('left');
                $term.classList.remove('right');

                // Add the appropriate class name
                $term.classList.add((left < half) ? 'left' : 'right');

                // Add in html
                if (!content_added) {
                    $term.insertAdjacentHTML('beforeend', `<div class="js-glossary-term-copy">${decoded_content}</div>`);
                    content_added = true;
                }


                if (localStorage.getItem('show_glossary_terms') === 'true') {
                    setTimeout(() => $term.classList.add('active'), 10);
                }

            });

            $term.addEventListener('mouseleave', (e) => {
                e.preventDefault();
                $term.classList.remove('active');
            });
        });
    }

    /*------------------------------------------------------------------
    Gloassary elements
    ------------------------------------------------------------------*/

    let $tooltips = $$('.js-tooltip');

    if ($tooltips) {
        $tooltips.forEach($tooltip => {

            let content_added = false;

            // Get the content
            let content = $tooltip.getAttribute('data-tooltip-content');

            $tooltip.addEventListener('mouseenter', (e) => {
                e.preventDefault();

                // Remove left and right class names
                $tooltip.classList.remove('left');
                $tooltip.classList.remove('right');

                // Add in html
                if (!content_added) {
                    $tooltip.insertAdjacentHTML('beforeend', `<div class="js-tooltip-copy">${content}</div>`);
                    content_added = true;
                }


                if (localStorage.getItem('show_glossary_terms') === 'true') {
                    setTimeout(() => $tooltip.classList.add('hovered'), 10);
                }

            });

            $tooltip.addEventListener('mouseleave', (e) => {
                e.preventDefault();
                $tooltip.classList.remove('hovered');
            });
        });
    }


    /*------------------------------------------------------------------
    Contact form
    ------------------------------------------------------------------*/

    let $enquiry_type = $('#ContactForm_FormPage_EnquiryType');

    if ($enquiry_type) {
        $enquiry_type.addEventListener('change', (e) => {
            let value = e.target.value;
            let $warning = $('.warning-message');
            let $submit = $('#ContactForm_FormPage_action_doSubmit');

            if (value === 'I need medical advice') {
                $warning.style.display = 'block';
                $submit.setAttribute('disabled', 'disabled');
            } else {
                $warning.style.display = 'none';
                $submit.removeAttribute('disabled');
            }
        });
    }

    /**
     * 
     * Toggle the glossary terms visibility
     * 
     * @param {boolean} visibility 
     */
    const toggleGlossaryVisibility = (visibility = true) => {
        // Show/hide the glossary terms from being visible on page
        document.body.classList.toggle('hide-glossary-terms', visibility);
    };


    /**
     * 
     * Toggle the glossary terms visibility
     * 
     */
    window.toggleGlossaryTerms = () => {
        if (localStorage.getItem('show_glossary_terms') === 'true') {
            // Update the glossary terms from localstorage
            localStorage.setItem('show_glossary_terms', 'false');

        } else {
            // Update the glossary terms from localstorage
            localStorage.setItem('show_glossary_terms', 'true');

        }

        toggleGlossaryVisibility(localStorage.getItem('show_glossary_terms') === 'true');
    };

    toggleGlossaryVisibility(localStorage.getItem('show_glossary_terms') === 'true');


    const toggleFavourites = (type) => {
        $('.favourites__items').className = `favourites__items ${type}`;
        $$('.js-toggle-favourite-type').forEach($toggle => {
            $toggle.classList.remove('active');
        });
        $(`.js-toggle-favourite-type[data-type="${type}"]`).classList.add('active');
        $('.js-favourites-title').textContent = type.charAt(0).toUpperCase() + type.slice(1);
    }

    let $favouriteToggle = $$('.js-toggle-favourite-type');

    if ($favouriteToggle) {
        $favouriteToggle.forEach($toggle => {
            $toggle.addEventListener('click', (e) => {
                e.preventDefault();
                let type = $toggle.getAttribute('data-type');
                toggleFavourites(type);
            });
        });
    }

});

// Select all elements with the class 'js-blob'
document.querySelectorAll(".js-blob").forEach(function (blobElement) {

    // Function to create and animate the blob
    function animateBlob(blobData) {
        let points = [];  // Array to hold the blob's points

        // Select the SVG path element that will represent the blob's shape
        let pathElement = blobData.element.querySelector(".path1");

        // Angle between points (in radians)
        let angleBetweenPoints = (2 * Math.PI) / blobData.numPoints;

        // Generate a random offset for animation start
        let randomOffset = Math.random() * (2 * Math.PI);

        // Create each point of the blob and initialize its animation parameters
        for (let i = 0; i < blobData.numPoints; i++) {
            let angle = randomOffset + i * angleBetweenPoints;

            // Initial position of the point (at minimum radius)
            let point = {
                x: blobData.centerX + Math.cos(angle) * blobData.minRadius,
                y: blobData.centerY + Math.sin(angle) * blobData.minRadius,
                angle: angle,  // Store angle for future reference
                radius: blobData.minRadius,
                direction: 1,  // Direction of movement (1 for expanding, -1 for contracting)
                speed: getRandom(blobData.minDuration, blobData.maxDuration)  // Random speed for each point
            };

            points.push(point);  // Add the point to the array
        }

        // Store points in the blobData object
        blobData.points = points;

        // Function to update the points and animate the blob
        function updatePoints() {
            points.forEach(point => {
                // Move the point between minRadius and maxRadius
                point.radius += point.direction * (1 / point.speed);

                // Reverse direction if the point reaches the boundaries
                if (point.radius >= blobData.maxRadius || point.radius <= blobData.minRadius) {
                    point.direction *= -1;
                }

                // Update the point's x and y coordinates based on its radius and angle
                point.x = blobData.centerX + Math.cos(point.angle) * point.radius;
                point.y = blobData.centerY + Math.sin(point.angle) * point.radius;
            });

            // Update the blob's path based on the new point positions
            let pathData = generateBlobPath(points, 1);
            pathElement.setAttribute("d", pathData);

            // Continue animating
            requestAnimationFrame(updatePoints);
        }

        // Start the animation
        requestAnimationFrame(updatePoints);

        // Play animation on mouse enter
        blobData.element.addEventListener("mouseenter", function () {
            blobData.element.classList.add("hover");
        });

        // Pause animation on mouse leave (can be done by not updating the points)
        blobData.element.addEventListener("mouseleave", function () {
            blobData.element.classList.remove("hover");
        });
    }

    // Function to generate the SVG path for the blob
    function generateBlobPath(points, smoothness) {
        if (points.length < 1) return "M0 0";  // If no points, return empty path

        smoothness = smoothness || 1;  // Default smoothness if not provided
        let path = "M" + points[0].x + " " + points[0].y + " C";  // Start the path

        // Loop through each point and create smooth curves
        for (let i = 0; i < points.length; i++) {
            let prevPoint = points[(i - 1 + points.length) % points.length];
            let currentPoint = points[i];
            let nextPoint = points[(i + 1) % points.length];
            let nextNextPoint = points[(i + 2) % points.length];

            // Calculate the control points for the bezier curve
            let controlPoint1X = currentPoint.x + (nextPoint.x - prevPoint.x) / 6 * smoothness;
            let controlPoint1Y = currentPoint.y + (nextPoint.y - prevPoint.y) / 6 * smoothness;
            let controlPoint2X = nextPoint.x - (nextNextPoint.x - currentPoint.x) / 6 * smoothness;
            let controlPoint2Y = nextPoint.y - (nextNextPoint.y - currentPoint.y) / 6 * smoothness;

            // Add the curve to the path
            path += " " + controlPoint1X + " " + controlPoint1Y + " " + controlPoint2X + " " + controlPoint2Y + " " + nextPoint.x + " " + nextPoint.y;
        }

        path += "z";  // Close the path
        return path;
    }

    // Helper function to get a random value between two numbers
    function getRandom(min, max) {
        return Math.random() * (max - min) + min;
    }

    // Call the animateBlob function with the blob element and its parameters
    animateBlob({
        element: blobElement,
        numPoints: 10,        // Number of points for the blob
        centerX: 500,         // X coordinate of the blob's center
        centerY: 500,         // Y coordinate of the blob's center
        minRadius: 300,       // Minimum radius of the blob
        maxRadius: 340,       // Maximum radius of the blob
        minDuration: 1,       // Minimum duration of the animation
        maxDuration: 2        // Maximum duration of the animation
    });
});